import React, { useState } from 'react';
import BoundFormGroup from './boundForm/BoundFormGroup';
import { postContactSupport } from '../../redux/actions/userActions';
import { notification } from 'antd';
import useBoundForm from '../hooks/useBoundForm';
import BasicSlideOut from './BasicSlideOut';

// Turn this feature off for all pages by setting SHOW_FORM to false
const SHOW_FORM = true;

const FloatingContactForm = () => {
  const [showForm, setShowForm] = useState(false);
  const [message, setMessage] = useState('');
  const form = useBoundForm({});

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  const handleKeyPress = (e) => {
    setMessage(e.target.value);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    // post form data to the server
    postContactSupport(
      {
        message,
      },
      (data, err) => {
        if (!err) {
          notification.success({
            message: 'Success',
            description: "We'll be in touch!",
          });
          setMessage('');
          form.reset();
          toggleForm();
        }
      },
    );
  };

  const fields = [
    [
      {
        id: 'message',
        placeholder: 'Please type your message here...',
        autoFocus: true,
        type: 'textarea',
        required: true,
        rows: 8,
        resize: 'vertical',
        label: 'Message',
        onChange: handleKeyPress,
      },
    ],
  ];

  if (!SHOW_FORM) {
    return <></>;
  }

  return (
    <div>
      <button
        id="floating-button"
        onClick={toggleForm}></button>
      {showForm && (
        <>
          <BasicSlideOut
            showSlideOut={showForm}
            hideSlideOut={toggleForm}
            title={'Contact Us'}
            body={
              <div style={{ width: '100%' }}>
                <BoundFormGroup
                  formId={form.id}
                  fields={fields}
                />
              </div>
            }
            submitText={'Submit'}
            onSubmit={handleFormSubmit}
          />
        </>
      )}
    </div>
  );
};

export default FloatingContactForm;
